import { render, staticRenderFns } from "./CreateCommunityBar.vue?vue&type=template&id=48714b9d&scoped=true"
import script from "./CreateCommunityBar.vue?vue&type=script&lang=js"
export * from "./CreateCommunityBar.vue?vue&type=script&lang=js"
import style0 from "./CreateCommunityBar.vue?vue&type=style&index=0&id=48714b9d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48714b9d",
  null
  
)

export default component.exports